import { productIdFormat } from "@redotech/redo-ids/ids";
import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import { PrinterOptionsSchema } from "@redotech/redo-model/printnode/printer";
import * as z from "zod";

export const generateBarcodeLabel = {
  name: "generateBarcodeLabel" as const,
  input: z.object({
    barcodeValue: z.string().min(1).optional(),
    sku: z.string().optional(),
    productTitle: z.string().optional(),
    labelSize: z.enum(barcodeLabelSize).optional(),
    showSku: z.boolean().optional(),
    showTitle: z.boolean().optional(),
    showPrice: z.boolean().optional(),
    showBarcodeValue: z.boolean().optional(),
    price: z.string().optional(),
    items: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          copies: z.number().int().nonnegative(),
        }),
      )
      .optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    idempotencyKey: z.string().optional(),
  }),
  output: z.object({
    pdfBase64: z.string(),
    printedToWorkstation: z.boolean().optional(),
  }),
};
